import { createApp } from 'vue';
import store from 'shared/store';
import './heroBannerBA-entry.scss';
import GlobalSearchFieldWrapper from './GlobalSearchFieldWrapper.vue';

const globalSearchFieldWrapper = document.querySelector('#global-search-field');

if (globalSearchFieldWrapper) {
	const app = createApp({
		name: 'GlobalSearchFieldWrapperApp',
	});
	app.use(store);
	app.component('global-search-field-wrapper', GlobalSearchFieldWrapper);

	app.mount(globalSearchFieldWrapper);
}
